import { JSX, use, useMemo, Suspense } from 'react'

import { Stack, Box, Separator } from '@chakra-ui/react'


import { HttpBody } from '@/lib/request'

import * as detective from '@/lib/detective.js'

import * as archive_storage from '@/storage/archive.js'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Loading from '@/components/ui/loading.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Empty from '@/components/ui/empty.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Status from './components/status.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Dataset from './components/dataset.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Complete from './components/complete.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Profile from './components/profile.tsx'






// eslint-disable-next-line @typescript-eslint/naming-convention
export function Marquee
(
	props: {
		doc: HttpBody<archive_storage.THydratedDocumentType>

	},

)
:	JSX.Element
{
	let { _id, is_online, is_signed } = props.doc

	return (
		<Box p="2" flex="auto">
			<Status online={is_online} signed={is_signed} />

			<Dataset _id={_id} mt="4" />

			<Complete doc={props.doc} mt="4" />

		</Box>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Retrieve
(
	props: {
		doc: Promise<null | HttpBody<archive_storage.THydratedDocumentType> >

	},

)
:	JSX.Element
{
	let doc = use(props.doc)

	if (detective.is_empty(doc) )
	{
		return (
			<Empty.Miss h="48vh" title="无效档案" description="该名员工尚未上传档案" />

		)

	}

	return (
		<Stack p="2" direction="row" minH="full">
			<Marquee doc={doc} />

			<Separator orientation="vertical" />

			<Profile doc={doc} />

		</Stack>


	)

}

export default function
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	let doc = useMemo(
		() => archive_storage.retrieve(props._id)
			.catch(
				() => null,

			),

		[props._id],

	)

	return (
		<Suspense fallback={<Loading.Default h="48vh" />}>
			<Retrieve doc={doc} />

		</Suspense>

	)

}
